import {ApiClient} from '@hconnect/apiclient'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import type {MaterialStorage, EmailSyncDetails} from '../types'

const emailParserKeyToResource: Record<
  keyof EmailSyncDetails,
  'email-column-name' | 'tonne-conversion-factor'
> = {
  emailColumnName: 'email-column-name',
  tonneConversionFactor: 'tonne-conversion-factor'
}

type Variables = {
  plantCode: string
  storageId: number
  key: keyof EmailSyncDetails
  dto: EmailSyncDetails
}

export const useEditStorageEmailParserConnection = ({
  onError,
  onSuccess
}: {
  onError?: (error: AxiosError, variables: Variables) => void
  onSuccess?: (data: MaterialStorage, variables: Variables) => void
} = {}) =>
  useMutation<MaterialStorage, AxiosError, Variables>({
    mutationFn: async ({plantCode, storageId, key, dto}) => {
      const response = await ApiClient.axiosInstance.patch<MaterialStorage>(
        `/plants/${plantCode}/material-storage/${storageId}/details/email-parser/${emailParserKeyToResource[key]}`,
        dto
      )
      return response.data
    },
    onError,
    onSuccess
  })
